
(function() {

  const $header = {
    header: document.querySelector('.js-st-Header'),
  }

  window.addEventListener('scroll', function(){
    var y = window.pageYOffset ;

    if(y > 200) {
      $header.header.classList.add('is-hide');

    } else {
      $header.header.classList.remove('is-hide');
    }

    if(y > 500) {
      $header.header.classList.add('is-fixed');
    } else {
      $header.header.classList.remove('is-fixed');

    }

  });
})();